<template>
  <div class="sub-category">
    <div class="category-header">
      <h1 class="category-title">{{ categoryData.name }}</h1>
    </div>

    <div class="products-grid">
      <div
        v-for="product in categoryData.products"
        :key="product.productId"
        class="product-card"
        @click="goToProduct(product.productId)"
      >
        <div class="product-image-container">
          <img
            v-if="product.coverImg"
            :src="getImageUrl(product.productId)"
            :alt="product.name"
            class="product-image"
          />
          <div v-else class="image-placeholder">No Image</div>
        </div>

        <div class="product-info">
          <h3 class="product-name">{{ product.name }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubCategory",
  props: {
    categoryData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getImageUrl(productId) {
      const isMobile = window.innerWidth <= 768;
      const fileName = isMobile ? "cover_mobile.webp" : "cover.webp";

      if (process.env.NODE_ENV === "development") {
        return `http://localhost:3000/assets/products/${productId}/${fileName}`;
      }
      return `/assets/products/${productId}/${fileName}`;
    },
    goToProduct(productId) {
      this.$router.push({ name: "ProductDetail", params: { id: productId } });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.sub-category {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.category-header {
  margin-bottom: 3rem;
  text-align: center;
}

.category-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: @color-text-title;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  position: relative;
  padding-bottom: 1rem;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 100%;
    height: 3px;
    background: @color-primary;
  }
}

.products-grid {
  .grid-equal-columns(4, 1.5rem);

  .tablet-up({
    .grid-equal-columns(3, 1rem);
  });

  .mobile-only({
    display: block;
    .product-card {
      max-width: 420px;
      margin: 0 auto 1.5rem;
    }
  });
}

.product-card {
  background: @color-bg-main;
  border-radius: @radius-base;
  overflow: hidden;
  border: 1px solid fade(@color-primary, 10%);
  box-shadow: 0 2px 6px fade(@color-primary, 8%);
  cursor: pointer;
  transition: all 0.3s @ease-out;

  &:hover {
    transform: translateY(-4px);

    .product-image {
      transform: scale(1.05);
    }
  }
}

/* ✅ 同一套比例规则 */

.product-image-container {
  width: 100%;
  aspect-ratio: 4 / 3;

  .mobile-only({
    aspect-ratio: 3 / 4;
  });
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

.product-info {
  padding: 1rem 0.8rem;
  text-align: center;
}

.product-name {
  font-size: 1.05rem;
  font-weight: 400;
  color: @color-text-title;
  margin: 0;
  .text-ellipsis(2);
}
</style>
